.radio-circle {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 24px;
  padding-top: 24px;
  padding-bottom: 32px;

  &.radio-circle-public {
    grid-template-columns: minmax(0, 1fr);
    max-width: 900px;
  }

  .radio-player-panel,
  .radio-social-panel {
    min-width: 0;
  }
  .radio-now-playing {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: #ecf8f1;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 16px;
  }
  .radio-station-group {
    margin: 20px 0;
  }
  .radio-station-group ul {
    list-style: none;
    padding: 0;
  }
  .radio-station-group li {
    display: flex;
    border: 1px solid #dbe3d2;
    border-radius: 6px;
    margin: 5px 0;
  }
  .radio-station-group .is-selected {
    border-color: #128a78;
    background: #ecf8f1;
  }
  .radio-tune {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    text-align: left;
    background: transparent;
    border: 0;
    padding: 10px;
  }
  .radio-tune strong,
  .radio-tune small {
    display: block;
    overflow-wrap: anywhere;
  }
  .radio-station-art {
    display: inline-grid;
    place-items: center;
    flex: 0 0 42px;
    height: 42px;
    border-radius: 6px;
    background: #065f46;
    color: #fff;
  }
  .radio-favourite {
    background: transparent;
    border: 0;
    padding: 10px 15px;
    font-size: 24px;
    color: #855d00;
  }
  button:focus-visible,
  a:focus-visible {
    outline: 2px solid #128a78;
    outline-offset: 2px;
  }
  .radio-chat-log {
    list-style: none;
    padding: 0;
    max-height: 420px;
    overflow: auto;
  }
  .radio-chat-log li {
    border-bottom: 1px solid #dbe3d2;
    padding: 10px 0;
  }
  .radio-chat-log p {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
  .radio-chat-form {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .radio-chat-form label {
    flex-basis: 100%;
  }
  .radio-chat-form input {
    flex: 1;
    min-width: 0;
  }
  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.tribe-header.has-radio-player {
  min-height: 0;
  .tribe-header-info {
    min-height: 0;
    padding-bottom: 24px;
  }
  .tribe-header-back {
    padding-top: 20px;
  }
  .tribe-intro {
    margin-top: 16px;
  }
}
